import React from 'react';
import { Button, Space, Typography } from 'antd';
import { AppstoreAddOutlined, ClearOutlined, ThunderboltOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface PlantingModeContentProps {
  isBusy: boolean;
  isEraseMode: boolean;
  multiSelectedBeds: Set<string>;
  isBulkPlacementMode?: boolean;
  bulkGridDimensions?: { rows: number; cols: number } | null;
  onToggleEraseMode: () => void;
  onOpenBulkPlacementModal?: () => void;
  onCancelBulkPlacement?: () => void;
  onBatchAction?: () => void;
}

const PlantingModeContent: React.FC<PlantingModeContentProps> = ({
  isBusy,
  isEraseMode,
  multiSelectedBeds,
  isBulkPlacementMode,
  bulkGridDimensions,
  onToggleEraseMode,
  onOpenBulkPlacementModal,
  onCancelBulkPlacement,
  onBatchAction,
}) => {
  if (isBulkPlacementMode && bulkGridDimensions) {
    return (
      <Space>
        <Text type="success">Режим размещения: {bulkGridDimensions.rows} × {bulkGridDimensions.cols} грядок</Text>
        <Text type="secondary">Наведите мышь на сетку и кликните для размещения</Text>
        <Button danger icon={<CloseOutlined />} onClick={onCancelBulkPlacement}>Отменить</Button>
      </Space>
    );
  }

  return (
    <Space wrap>
      <Button type="primary" icon={<AppstoreAddOutlined />} onClick={onOpenBulkPlacementModal} disabled={isBusy}>Массовое размещение</Button>
      <Button type={isEraseMode ? 'primary' : 'default'} danger={isEraseMode} icon={<ClearOutlined />} onClick={onToggleEraseMode} disabled={isBusy}>Стирание</Button>
      {onBatchAction && multiSelectedBeds.size > 0 && (
        <Button type="primary" icon={<ThunderboltOutlined />} onClick={onBatchAction} disabled={isBusy} style={{ background: '#52c41a', borderColor: '#52c41a' }}>
          Действие ({multiSelectedBeds.size} грядок)
        </Button>
      )}
      {!isEraseMode && multiSelectedBeds.size === 0 && <Text type="secondary" style={{ marginLeft: 8 }}>Ctrl+Click по грядкам для групповых действий</Text>}
      {isEraseMode && <Text type="warning">Режим стирания — кликайте по клеткам для удаления</Text>}
    </Space>
  );
};

export default PlantingModeContent;
